$(function() {
        $("#cioPw").val("");
        $(".js-toggle-password-visibility").on("touchstart mousedown",function () {
            $(this).prev().children(".form-control").attr("type","text");
        }).on("touchend mouseup mouseleave mouseout",function () {
            $(this).prev().children(".form-control").attr("type","password");
        });
});
